// Default values for Earth
SJ.V = {
	maxDailyJumpsCount: 100,

	jumperFriction: 0.0065,
	jumperAngularFriction: 0.96,
	jumperJumpForce: 5,
	jumperTurnForce: 0.15,
	goodLandingAngle: 30, // in degrees
	maxLandingHeight: 10,

	texturesNames: {},
};

const load = (v, callBack) => {
	SJ.V.jumperJumpForce = v.jumpForce || SJ.V.jumperJumpForce;
	SJ.V.jumperTurnForce = v.turnForce || SJ.V.jumperTurnForce;
	SJ.V.PIXELS_TO_METERS = v.PIXELS_TO_METERS || 0.03;
	SJ.V.POINTS_PER_METER = v.POINTS_PER_METER || 1.8;
	SJ.V.KPoint = v.KPoint || 100;
	SJ.V.arbiterRatePoints = v.arbiterRatePoints || 0;
	SJ.V.HSPoint = v.HSPoint || 120;
	SJ.V.padSize = v.padSize;
	SJ.V.padScale = v.padScale || 1.0;
	SJ.V.foregroundScale = v.foregroundScale || 1;
	SJ.V.jumperScale = v.jumperScale || 0.95;
	SJ.V.textureOffset = v.textureOffset || { x: 0, y: 0 };
	SJ.V.minJumpDistance = v.minJumpDistance;
	SJ.V.maxJumpDistance = v.maxJumpDistance;
	SJ.V.airFriction = v.airFriction;
	SJ.V.padFriction = v.padFriction;
	SJ.V.liftForce = v.liftForce;
	SJ.V.windLiftForce = v.windLiftForce || 0.005;
	SJ.V.airRotateForce = v.airRotateForce;
	SJ.V.airMinForce = v.airMinForce;
	SJ.V.airMaxForce = v.airMaxForce;
	SJ.V.airDynamics = v.airDynamics;
	SJ.V.liftForceAngle = v.liftForceAngle || 0;
	SJ.V.gravity = v.gravity;
	SJ.V.texturesNames.pad = v.texturesNames.pad;
	SJ.V.texturesNames.foreground = v.texturesNames.foreground || null;
	SJ.V.texturesNames.middleground = v.texturesNames.middleground || null;
	SJ.V.texturesNames.background = v.texturesNames.background;
	SJ.V.screenLayer = v.screenLayer || [];
	SJ.V.cameraTopPath = v.cameraTopPath;
	SJ.V.cameraBottomPath = v.cameraBottomPath;
	SJ.V.jumpStartPoint = v.jumpStartPoint;
	SJ.V.padPullingPoints = v.padPullingPoints;
	SJ.V.padCollisionPoints = v.padCollisionPoints;
	SJ.V.jumperPosition = v.jumperPosition || { x: 213.0, y: 334.0 };
	SJ.V.pointK = v.pointK;
	SJ.V.jumpEndPoint = v.padPullingPoints[v.padPullingPoints.length - 1].x;
	SJ.V.minCameraPosition = v.minCameraPosition;
	SJ.V.cameraScale = v.cameraScale || 1;
	SJ.V.maxJumpBoost = 1;
	SJ.V.boostAreaWidth = 200;

	SJ.V.weatherType = v.weatherType || 'null';
	SJ.V.weatherIntensity = v.weatherIntensity || [0.1, 1];
	SJ.V.weatherSpeed = v.weatherSpeed || [0.1, 1.5];

	SJ.V.graphicsSettings = 'low';
	SJ.V.mapType = v.mapType;

	SJ.V.medalsDistancePoints = v.medalsDistancePoints;

	callBack();
};

SJ.loadVariablesFromFile = (fileName, callBack) => {
	const mapFileName = `skijump-js/sj-locations/sj-${fileName}-${SJ.settings.graphic}.json`;
	console.log(`Map file: ${mapFileName}`);

	loadJSON(
		mapFileName,
		(v) => {
			load(v, callBack);
		},
		() => {
			console.log(
				`%c NO ${SJ.settings.graphic} SETTINGS FOR THIS MAP`,
				'color: red'
			);
			console.log(
				'%c LOADING MAP ON DEFAULT GRAPHICS SETTINGS',
				'color: orange'
			);

			loadJSON(`skijump-js/sj-locations/sj-${fileName}-low.json`, (v) => {
				load(v, callBack);
			});
		}
	);
};

SJ.V.showWorldVariables = () => {
	console.log('%c -----WORLD VARIABLES-----', 'color: orange');
	console.log('Minimum jump distans: ' + SJ.V.minJumpDistance);
	console.log('Maximum jump distans: ' + SJ.V.maxJumpDistance);
	console.log('Air friction: ' + SJ.V.airFriction);
	console.log('Pad friction: ' + SJ.V.padFriction);
	console.log('Air density: ' + SJ.V.liftForce);
	console.log('Air rotate force: ' + SJ.V.airRotateForce);
	console.log('Min air speed: ' + SJ.V.airMinForce);
	console.log('Max air speed: ' + SJ.V.airMaxForce);
	console.log('Air dynamics: ' + SJ.V.airDynamics);
	console.log('Gravity: ' + SJ.V.gravity);
	console.log('Max jump boost: ' + SJ.V.maxJumpBoost);
	console.log('Boost area width [px]: ' + SJ.V.boostAreaWidth);
	console.log('Jumper turn force: ' + SJ.V.jumperTurnForce);
	console.log('Jumper jump force: ' + SJ.V.jumperJumpForce);
	console.log('Good landing angle: ' + SJ.V.goodLandingAngle);
	console.log('K point: ' + SJ.V.KPoint);
};
